import {MDBBadge} from "mdb-react-ui-kit";
import {Link} from "react-router-dom";
import React from "react";
import {getPrintInfo} from "./PrintJobs";

export function loadPrintJobs(sort, search) {

    const returnList = [];

    if (search.length !== 0 && !search.includes("didn't match any jobs")) {
        for (const job in search) {
            const jobInfo = getPrintInfo(search[job]);
            returnList.push(
                <div>
                    <div className="list-section">
                        <h3 className="list-section-header">{search[job].name}
                            <MDBBadge pill className='info_float mt-0' color='info_float'> {jobInfo[2]}</MDBBadge>
                        </h3>

                        <Link to={"/management/print/view"} state={search[job]}>
                            <button className="btn btn-primary list-section-btn float-right"> View Details</button>
                        </Link>
                        <p className="list-section-date-time">{jobInfo[0]} {jobInfo[1]}</p>
                        <br/><br/>
                    </div>
                    <br/>


                </div>
            );
        }
    } else if (search.length !== 0) {
        returnList.push(
            <div>
                <h3 className="search-message"> {search} </h3>
            </div>
        )
    }

    if (search.length !== 0) {
        returnList.push(
            <div>
                <hr/>
                <br/>
            </div>
        )
    }
    //Could filter here so only the search results are displayed?
    if (true) {
        for (const job in sort) {
            const jobInfo = getPrintInfo(sort[job]);
            returnList.push(
                <div>
                    <div className="list-section">
                        <h3 className="list-section-header">{sort[job].name}
                            <MDBBadge pill className='info_float mt-0' color='info_float'> {jobInfo[2]}</MDBBadge>
                        </h3>

                        <Link to={"/management/print/view"} state={sort[job]}>
                            <button className="btn btn-primary list-section-btn float-right"> View Details</button>
                        </Link>
                        <p className="list-section-date-time">{jobInfo[0]} {jobInfo[1]}</p>
                        <br/><br/>
                    </div>
                    <div className="page-break"></div>
                </div>
            );
        }
    }
    return returnList;

}